import React from "react";
import PropTypes from "prop-types";
import ExitGameButton from "../../components/ExitGameButton";
import BaseIcon from "../../components/BaseIcon";
import "./style.scss";
import { useTranslation } from "react-i18next";

export default function TopMobileModal({ isOpen, toggleModal }) {
  TopMobileModal.propTypes = {
    isOpen: PropTypes.bool,
    toggleModal: PropTypes.func,
  };
  const { t } = useTranslation();
  const closeModalByBackdrop = (event) => {
    event.target.id === "backdrop" && toggleModal();
  };
  const closeModal = () => {
    toggleModal();
  };
  return (
    <div
      onClick={closeModalByBackdrop}
      id="backdrop"
      className={`mobile-top-modal-container ${
        isOpen && "mobile-top-modal-container_isOpen"
      }`}
    >
      <div
        className={`mobile-top-modal ${
          isOpen && "mobile-top-modal_modal-opened"
        }`}
      >
        <div className="mobile-top-modal__header">
          <span className="mobile-top-modal__header__title">
            {t("name_game")}
          </span>
          <BaseIcon
            onClick={closeModal}
            name="close_cross"
            className="mobile-top-modal__header__close"
          />
        </div>
        <div>
          <ExitGameButton onClick={closeModal} title={t("back_to_menu")} />
        </div>
      </div>
    </div>
  );
}
